import React, { useState } from "react";
import { useMount } from "react-use";
import Modal from "react-modal";
import moment from "moment";
// import c from "../../data/curriculum.json";
import Icon from "../../components/common/Icon";
import {
  Button,
  DateInput,
  IconButton,
  LinkButton,
  SaveButton,
  TimeSelect,
  TextInput,
  TextArea,
} from "../../components/common/Forms";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { addLecture, getLecture } from "../../api";
import { useMutation, useQueryClient } from "react-query";
import Toast from "../../components/common/Toast";
import {
  lectureCurriculumState,
  lectureDateState,
  lectureHostState,
  lectureInfoState,
  lectureItemState,
  lecturePlaceState,
  lectureReportState,
  lectureTitleState,
} from "../../states/atoms/lectureState";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";

const LectureAddPage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const bUpdate = pathname.indexOf("/update/") > 0;
  const { lecture_id } = useParams();
  const id = useRecoilValue(lectureItemState);
  const [title, setTitle] = useRecoilState(lectureTitleState);
  const [date, setDate] = useRecoilState(lectureDateState);
  const [place, setPlace] = useRecoilState(lecturePlaceState);
  const [host, setHost] = useRecoilState(lectureHostState);
  const [info, setInfo] = useRecoilState(lectureInfoState);
  const [curriculum, setCurriculum] = useRecoilState(lectureCurriculumState);
  const [report, setReport] = useRecoilState(lectureReportState);
  const resetTitle = useResetRecoilState(lectureTitleState);
  const resetDate = useResetRecoilState(lectureDateState);
  const resetPlace = useResetRecoilState(lecturePlaceState);
  const resetHost = useResetRecoilState(lectureHostState);
  const resetInfo = useResetRecoilState(lectureInfoState);
  const resetCurriculum = useResetRecoilState(lectureCurriculumState);
  const resetReport = useResetRecoilState(lectureReportState);
  const resetItem = useResetRecoilState(lectureItemState);
  const [isOpen, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const queryClient = useQueryClient();

  const getLectureItem = async () => {
    const res = await queryClient.fetchQuery(["lecture/get/item", lecture_id], {
      queryFn: () => getLecture({ lecture_id }),
    });
    const { result, error, data } = res;
    if (result && data) {
      const [tmp] = data;
      setError(false);
      setTitle(tmp.title);
      const { start_date, end_date } = tmp;
      const sDate = new moment(start_date);
      const eDate = new moment(end_date);
      setDate([
        {
          date: sDate.format("YYYY-MM-DD"),
          hour: sDate.format("HH"),
          minute: sDate.format("mm"),
        },
        {
          date: eDate.format("YYYY-MM-DD"),
          hour: eDate.format("HH"),
          minute: eDate.format("mm"),
        },
      ]);
      setPlace(tmp.place || "");
      setHost(tmp.host || "");
      setInfo(tmp.info || []);
      setCurriculum(tmp.curriculum || []);
      setReport(tmp.report || []);
    } else {
      setError(error || false);
    }
  };

  const lectureMttn = useMutation({
    mutationFn: addLecture,
    onSettled: (data) => {
      const { result, error } = data;
      setOpen(false);
      setError(false);
      if (result) {
        setOpen(true);
      } else {
        setError(error || "강의 등록 중 오류가 발생했습니다.");
      }
      queryClient.invalidateQueries({ queryKey: ["lecture/get/item"] });
    },
  });

  const reset = () => {
    resetTitle();
    resetDate();
    resetPlace();
    resetHost();
    resetInfo();
    resetCurriculum();
    resetReport();
    resetItem();
  };

  useMount(() => {
    if (!id && !bUpdate) {
      reset();
    } else if (!id && bUpdate) {
      getLectureItem();
    }
  });

  const handleAddForm = (type, i, j) => () => {
    if (type === "info") {
      return setInfo([...info, { label: "", content: "" }]);
    } else if (type === "chapter") {
      return setCurriculum([
        ...curriculum,
        { content: "", list: [], datetime: {} },
      ]);
    } else if (type === "subject") {
      const { list, content, datetime } = curriculum[i];
      const newCurr = [...curriculum];
      newCurr.splice(i, 1, {
        content,
        list: [...list, { subject: "", items: [] }],
        datetime,
      });
      return setCurriculum(newCurr);
    } else if (type === "content") {
      const { list, content, datetime } = curriculum[i];
      const { items, subject } = list[j];
      const newList = [...list];
      newList.splice(j, 1, { subject, items: [...items, ""] });
      const newCurr = [...curriculum];
      newCurr.splice(i, 1, { content, datetime, list: newList });
      return setCurriculum(newCurr);
    }
  };

  const handleDelInfo = (i) => () => {
    const newInfo = [...info];
    newInfo.splice(i, 1);
    setInfo(newInfo);
  };

  const handleDelForm = (i, j, k) => () => {
    const { list, content, datetime } = curriculum[i];
    if (k !== undefined) {
      const { items: oItems, subject } = list[j];
      const items = [...oItems];
      items.splice(k, 1);
      const newList = [...list];
      newList.splice(j, 1, { subject, items });
      const newCurr = [...curriculum];
      newCurr.splice(i, 1, { content, datetime, list: newList });
      return setCurriculum(newCurr);
    } else if (j !== undefined) {
      const newList = [...list];
      newList.splice(j, 1);
      const newCurr = [...curriculum];
      newCurr.splice(i, 1, { content, datetime, list: newList });
      return setCurriculum(newCurr);
    } else {
      if (
        window.confirm(
          `${i + 1}회차 강의 일정 내용이 모두 삭제됩니다. 계속하시겠습니까?`
        )
      ) {
        const newCurr = [...curriculum];
        newCurr.splice(i, 1);
        return setCurriculum(newCurr);
      }
    }
  };

  const handleChangeTitle = (e) => {
    setTitle(e.target.value);
  };

  const handleChangeCurriculum = (i, j, k) => (e) => {
    const newCurr = [...curriculum];
    const { list, content, datetime } = curriculum[i];
    if (k !== undefined) {
      const newList = [...list];
      const { subject, items: oItems } = newList[j];
      const items = [...oItems];
      items.splice(k, 1, e.target.value);
      newList.splice(j, 1, { subject, items });
      newCurr.splice(i, 1, { content, datetime, list: newList });
    } else if (j !== undefined) {
      const newList = [...list];
      newList.splice(j, 1, { subject: e.target.value, items: list[j].items });
      newCurr.splice(i, 1, { content, datetime, list: newList });
    } else {
      const prop = e.target.id.split("_")[2];
      if (prop) {
        const [se, hm] = prop.split("-");
        if (se && hm) {
          newCurr.splice(i, 1, {
            datetime: {
              ...datetime,
              [se]: { ...datetime[se], [hm]: e.target.value },
            },
            content,
            list,
          });
        } else {
          newCurr.splice(i, 1, {
            datetime: { ...datetime, [prop]: e.target.value },
            content,
            list,
          });
        }
      } else {
        newCurr.splice(i, 1, { content: e.target.value, datetime, list });
      }
    }
    setCurriculum(newCurr);
  };

  const handleChangeDate = (e) => {
    const newDate = [...date];
    const idx = e.target.id.indexOf("start") > 0 ? 0 : 1;
    if (e.target.id.indexOf("date") === 0) {
      newDate.splice(idx, 1, { ...date[idx], date: e.target.value });
    } else if (e.target.id.indexOf("hour") === 0) {
      newDate.splice(idx, 1, { ...date[idx], hour: e.target.value });
    } else {
      newDate.splice(idx, 1, { ...date[idx], minute: e.target.value });
    }
    setDate(newDate);
  };

  const handlePlace = (e) => {
    if (e.target.id) {
      setPlace(e.target.value);
    } else {
      setPlace("");
    }
  };

  const handleHost = (e) => {
    if (e.target.id) {
      setHost(e.target.value);
    } else {
      setHost("");
    }
  };

  const handleReport = (e) => {
    if (e.target.id) {
      setReport(e.target.value.split(/\r|\r\n|\n/));
    } else {
      setReport([]);
    }
  };

  const handleInfo = (e) => {
    const arr = e.target.id.split("_");
    const i = Number(arr[2]);
    const newInfo = [...info];
    newInfo.splice(i, 1, { ...newInfo[i], [arr[1]]: e.target.value });
    setInfo([...newInfo]);
  };

  const handleSave = () => {
    if (!title) {
      return setError("제목을 입력하세요.");
    }
    if (date.length === 2) {
      if (
        date[0] &&
        (!date[0].date || !(date[0].hour >= 0) || !(date[0].minute >= 0))
      ) {
        return setError("수업 시작 일자를 입력하세요.");
      }
      if (
        date[1] &&
        (!date[1].date || !(date[1].hour >= 0) || !(date[1].minute >= 0))
      ) {
        return setError("수업 종료 일자를 입력하세요.");
      }
    }
    if (!place) {
      return setError("수업 장소를 입력하세요.");
    }
    if (info) {
      if (info.length === 0) return setError("수업 정보를 입력하세요.");
      const msg = info.reduce((ac, v) => {
        if ("label" in v && "content" in v && v.label && v.content) return ac;
        return "수업 정보를 정확히 입력하세요.";
      }, "");
      if (msg) return setError(msg);
    }
    if (curriculum) {
      if (curriculum.length === 0) return setError("커리큘럼을 입력하세요.");
      const msg = curriculum.reduce((ac, v) => {
        if (v && "datetime" in v && "content" in v && "list" in v) {
          if (v.datetime) {
            if (
              "date" in v.datetime &&
              "start" in v.datetime &&
              "hour" in v.datetime.start &&
              v.datetime.start.hour >= 0 &&
              "min" in v.datetime.start &&
              v.datetime.start.min >= 0 &&
              "end" in v.datetime &&
              "hour" in v.datetime.end &&
              v.datetime.end.hour >= 0 &&
              "min" in v.datetime.end &&
              v.datetime.end.min >= 0
            )
              return ac;
            return "커리큘럼 날짜 정보를 정확히 입력하세요.";
          }
          if (!v.content) return "커리큘럼 학습 내용 정보를 정확히 입력하세요.";
          if (v.list && v.list.length) {
            const msg = v.list.reduce((ac, v) => {
              if ("subject" in v && "items" in v && v.subject && v.items.length)
                return ac;
              return "학습 주제 내용을 정확히 입력하세요.";
            }, "");
            if (msg) return msg;
          }
          return ac;
        }
        return "커리큘럼 정보를 정확히 입력하세요.";
      }, "");
      if (msg) return setError(msg);
    }
    if (!report || report.length === 0) {
      return setError("리포트 요약 정보를 입력하세요.");
    }
    if (!host) {
      return setError("주최 정보를 입력하세요.");
    }
    lectureMttn.mutate({
      title,
      date,
      place,
      host,
      info,
      curriculum,
      report,
      id: lecture_id,
    });
  };

  const handleClose = () => {
    setOpen(false);
    return navigate("/");
  };

  return (
    <section className="min-h-screen overflow-y-auto md:mt-4">
      <div className="w-full mx-auto overflow-hidden shadow-md md:rounded-lg md:w-9/12">
        <div className="p-4 bg-cyan-500 ">
          <div className="mx-auto lg:w-full lg:mx-0">
            <div className="inline-flex items-center w-full space-x-4">
              <TextInput
                className="flex-1 w-full h-12 p-2 text-3xl font-bold text-white bg-transparent border shadow-sm border-zinc-100 placeholder-zinc-50 placeholder:opacity-80 "
                id="class_name"
                onChange={handleChangeTitle}
                placeholder="수업이름을 입력하세요."
                value={title}
              />
            </div>
          </div>
        </div>
        <div className="space-y-6 bg-white">
          <hr />
          <div className="items-center w-full p-4 space-y-4 lg:space-y-0">
            <h2 className="mx-auto font-bold text-normal">수업 일시</h2>
            <div className="mx-auto">
              <div className="flex flex-col gap-4">
                {date.map(({ date, hour, minute }, i) => (
                  <div
                    className="inline-flex items-center gap-4"
                    key={`${i ? "end" : "start"}_item`}
                  >
                    <h3 className="w-12 text-sm font-bold text-end">
                      {i ? "종료" : "시작"}
                    </h3>
                    <DateInput
                      id={`date_${i === 0 ? "start" : "end"}`}
                      value={date}
                      onChange={handleChangeDate}
                    />
                    <TimeSelect
                      id={`hour_${i === 0 ? "start" : "end"}`}
                      type="hour"
                      onChange={handleChangeDate}
                      value={hour}
                    />
                    <TimeSelect
                      id={`min_${i === 0 ? "start" : "end"}`}
                      type="min"
                      value={minute}
                      onChange={handleChangeDate}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <hr />
          <div className="items-center w-full p-4 space-y-4 lg:space-y-0">
            <h2 className="mx-auto font-bold text-normal">수업 장소</h2>
            <div className="mx-auto">
              <div className="flex flex-col gap-4">
                <div className="inline-flex items-center gap-2">
                  <TextInput
                    className="flex-1 w-auto p-2"
                    id="place"
                    onChange={handlePlace}
                    placeholder="장소를 입력하세요."
                    value={place}
                  />
                  <IconButton onClick={handlePlace}>
                    <Icon name="x-circle" />
                  </IconButton>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="items-center w-full p-4 space-y-4 lg:space-y-0">
            <h2 className="mx-auto font-bold text-normal">수업 정보</h2>
            <div className="mx-auto">
              <div className="flex flex-col gap-2">
                {info.map(({ label, content }, i) => (
                  <div
                    className="inline-flex items-center gap-2"
                    key={`info_${i}`}
                  >
                    <TextInput
                      className="p-2 font-bold text-right"
                      id={`info_label_${i}`}
                      onChange={handleInfo}
                      placeholder="레이블"
                      value={label}
                    />
                    <TextInput
                      className="flex-1 w-auto p-2"
                      id={`info_content_${i}`}
                      onChange={handleInfo}
                      placeholder="내용"
                      type="text"
                      value={content}
                    />
                    <IconButton onClick={handleDelInfo(i)}>
                      <Icon name="x-circle" />
                    </IconButton>
                  </div>
                ))}
                <Button
                  type="primary"
                  size="sm"
                  onClick={handleAddForm("info")}
                >
                  <Icon name="plus" size="sm" />
                  수업정보 추가
                </Button>
              </div>
            </div>
          </div>
          <hr />
          <div className="items-center w-full p-4 space-y-4 lg:space-y-0">
            <h2 className="mx-auto font-bold text-normal">커리큘럼</h2>
            <div className="mx-auto">
              <ul className="flex flex-col gap-2">
                {curriculum.map(({ content, list, datetime }, i) => (
                  <li
                    className="flex flex-col gap-2 px-2 py-4 rounded-md bg-zinc-200"
                    key={`curr_${i}`}
                  >
                    <div className="inline-flex items-center gap-2">
                      <h3 className="inline-block w-10 text-sm font-bold text-right">{`${
                        i + 1
                      }회차`}</h3>
                      <TextInput
                        className="flex-1 w-full p-2"
                        id={`curr_${i}`}
                        onChange={handleChangeCurriculum(i)}
                        value={content || ""}
                      />
                      <IconButton on onClick={handleDelForm(i)}>
                        <Icon name="x-circle" />
                      </IconButton>
                    </div>
                    <div className="inline-flex items-center gap-2">
                      <h3 className="inline-block w-10 text-sm font-bold text-right">
                        날짜
                      </h3>
                      <DateInput
                        id={`curr_${i}_date`}
                        onChange={handleChangeCurriculum(i)}
                        value={
                          (datetime && "date" in datetime && datetime.date) ||
                          ""
                        }
                      />
                      <TimeSelect
                        id={`curr_${i}_start-hour`}
                        type="hour"
                        onChange={handleChangeCurriculum(i)}
                        value={
                          datetime &&
                          "start" in datetime &&
                          "hour" in datetime.start &&
                          datetime.start.hour
                        }
                      />
                      <TimeSelect
                        id={`curr_${i}_start-min`}
                        type="min"
                        onChange={handleChangeCurriculum(i)}
                        value={
                          datetime &&
                          "start" in datetime &&
                          "min" in datetime.start &&
                          datetime.start.min
                        }
                      />
                      <span>~</span>
                      <TimeSelect
                        id={`curr_${i}_end-hour`}
                        type="hour"
                        onChange={handleChangeCurriculum(i)}
                        value={
                          datetime &&
                          "end" in datetime &&
                          "hour" in datetime.end &&
                          datetime.end.hour
                        }
                      />
                      <TimeSelect
                        id={`curr_${i}_end-min`}
                        type="min"
                        onChange={handleChangeCurriculum(i)}
                        value={
                          datetime &&
                          "end" in datetime &&
                          "min" in datetime.end &&
                          datetime.end.min
                        }
                      />
                    </div>
                    <ul className="flex flex-col gap-4 ml-8">
                      {list.map(({ subject, items }, j) => (
                        <li
                          className="flex flex-col gap-2"
                          key={`curr_${i}_subject_${j}`}
                        >
                          <div className="inline-flex items-center gap-2">
                            <h3 className="inline-block text-sm font-bold">
                              {`${j + 1}. 학습 주제`}
                            </h3>
                            <TextInput
                              className="flex-1 w-auto p-2 "
                              id={`curr_${i}_${j}`}
                              onChange={handleChangeCurriculum(i, j)}
                              type="text"
                              value={subject}
                            />
                            <IconButton on onClick={handleDelForm(i, j)}>
                              <Icon name="x-circle" />
                            </IconButton>
                          </div>
                          <div className="flex flex-col gap-1 ml-4">
                            <h3 className="inline-block text-sm font-bold">
                              학습 내용
                            </h3>
                            {items.map((v, k) => (
                              <div
                                className="inline-flex items-center gap-2"
                                key={`curr_${i}_subject_${j}_${k}`}
                              >
                                <TextInput
                                  className="flex-1 w-auto p-2"
                                  id={`curr_${i}_${j}_${k}`}
                                  onChange={handleChangeCurriculum(i, j, k)}
                                  type="text"
                                  value={v}
                                />
                                <IconButton on onClick={handleDelForm(i, j, k)}>
                                  <Icon name="x-circle" />
                                </IconButton>
                              </div>
                            ))}
                            <LinkButton
                              onClick={handleAddForm("content", i, j)}
                            >
                              <Icon name="plus" size="sm" />
                              학습 내용 추가
                            </LinkButton>
                          </div>
                        </li>
                      ))}
                      <Button
                        type="primary"
                        size="sm"
                        className="w-1/4 bg-white"
                        outlined
                        onClick={handleAddForm("subject", i)}
                      >
                        <Icon name="plus" size="sm" />
                        학습 주제 추가
                      </Button>
                    </ul>
                  </li>
                ))}
                <Button
                  type="primary"
                  size="sm"
                  onClick={handleAddForm("chapter")}
                >
                  <Icon name="plus" size="sm" />
                  강의 일정 추가
                </Button>
              </ul>
            </div>
          </div>
          <hr />
          <div className="items-center w-full p-4 space-y-4 lg:space-y-0">
            <h2 className="mx-auto font-bold text-normal">리포트 요약</h2>
            <div className="mx-auto">
              <div className="flex flex-col gap-4">
                <div className="inline-flex items-center gap-2">
                  <TextArea
                    id="report"
                    className="flex-1 w-full p-2 bg-white shadow-sm text-sm"
                    onChange={handleReport}
                    placeholder="리포트에 들어갈 해당 강의에 대한 내용을 입력하세요."
                    rows={3}
                    value={report.join("\n")}
                  />
                  <IconButton on onClick={handleReport}>
                    <Icon name="x-circle" />
                  </IconButton>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="items-center w-full p-4 space-y-4 lg:space-y-0">
            <h2 className="mx-auto font-bold text-normal">주최 정보</h2>
            <div className="mx-auto">
              <div className="flex flex-col gap-4">
                <div className="inline-flex items-center gap-2">
                  <TextInput
                    className="flex-1 w-auto p-2"
                    id="host"
                    onChange={handleHost}
                    placeholder="주최 정보를 입력하세요."
                    value={host}
                  />
                  <IconButton on onClick={handleHost}>
                    <Icon name="x-circle" />
                  </IconButton>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="w-full px-4 pb-4 ml-auto">
            <SaveButton onClick={handleSave}>저장</SaveButton>
          </div>
        </div>
      </div>
      <Toast
        {...{
          ms: 2500,
          show: !!error,
          type: "error",
          text: error,
          onClose: () => setError(false),
        }}
      />
      <Modal
        ariaHideApp={false}
        className="flex h-full text-center"
        isOpen={isOpen}
        onRequestClose={handleClose}
      >
        <div className="m-auto bg-white shadow-xl card w-96">
          <div className="card-body">
            <h2 className="card-title">{title}</h2>
            {!bUpdate && <p>강의가 정상적으로 등록되었습니다.</p>}
            {bUpdate && <p>강의가 정상적으로 수정되었습니다.</p>}
            <div className="justify-center mt-4 card-actions">
              <Button type="primary" block onClick={handleClose}>
                확인
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </section>
  );
};

export default LectureAddPage;
